import { FC, useMemo } from "react";

import { IconDashesHorizontal } from "@/components/_icons/IconDashesHorizontal";
import { Icon, iconTypefromString } from "@/components/_molecules/icon-picker/icon.schema";
import { IconView } from "@/components/_molecules/icon-picker/icon-view";
import { cn } from "@/lib/cn";

import { TeamWithoutMembershipList } from "../models/team-model";

export interface TeamIconProps {
  team?: TeamWithoutMembershipList | null | undefined;
  className?: string;
}

export const TeamIcon: FC<TeamIconProps> = ({ team, ...props }) => {
  const icon = useMemo(() => {
    if (!team) {
      return null;
    }

    if (!team.logo) {
      return null;
    }

    if (!team.logoType) {
      return null;
    }

    const iconType = iconTypefromString(team.logoType);

    if (!iconType) {
      return null;
    }

    return {
      value: team.logo,
      mode: iconType,
      color: team.color,
    } as Icon;
  }, [team]);

  if (!icon) {
    return <IconDashesHorizontal className={cn(["h-3 w-3 text-sm text-muted-foreground", props.className])} />;
  }

  return <IconView icon={icon.value} iconType={icon.mode} color={icon.color ?? undefined} className={cn(["h-3 w-3 text-sm", props.className])} />;
};
